import { render } from "./AccountSettingsModal.vue?vue&type=template&id=12e96baf&scoped=true"
import script from "./AccountSettingsModal.vue?vue&type=script&lang=js"
export * from "./AccountSettingsModal.vue?vue&type=script&lang=js"

import "./AccountSettingsModal.vue?vue&type=style&index=0&id=12e96baf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e96baf"]])

export default __exports__